import { render, staticRenderFns } from "./EventPriceConfigInputPopup.vue?vue&type=template&id=42a10338&"
import script from "./EventPriceConfigInputPopup.vue?vue&type=script&lang=js&"
export * from "./EventPriceConfigInputPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports